import React from 'react';

import EventBox from './event-box';
import EventDefault from './event-default';
import EventEvalution from './event-evalution';
import EventCardField from './event-get-card-filed';
import MessageEventIntGuidance from './event-intelligence-guidance';
import MessageAgentUpdateCardField from './event-agent-update-card-filed';
import MessageClientUpdateCardField from './event-client-update-card-filed';
import MessageAgentUpdateConvTag from './event-agent-update-conv-tag';
import EventWithdraw from './event-withdraw';
import EventInitConv from './event-init-conv';
import EventSensitiveWords from './event-sensitive-words';
import { EventCopyButton } from './event-copy-button';
import MessageClickQuickBtn from './event-quick-btn-click';
import EventAgentRedirect from './event-agent-redirect';
import EventRedirectSummary from './event-summary-conv';
import EventPhoneCheck from './event-phone-check';
import { EventWechatCopy } from './event-wechat-copy';
import EventMsgAppOpen from './event-msg-app-open';

const MessageBase = props => {
  const { isLastStream = false } = props?.data;

  const has_operator_msg = props?.data?.extra?.operator_msg?.length;

  const renderEvent = item => {
    const { data, handleReEdit } = item;
    const { eventType } = data;
    switch (eventType) {
      case 'withdraw':
        return <EventWithdraw {...item} handleReEdit={handleReEdit} />;
      case 'base':
        return <EventDefault {...item} />;
      case 'evalution':
        return <EventEvalution {...item} />;
      case 'cardField':
        return <EventCardField {...item} />;
      case 'clientUpdateCardField':
        return <MessageClientUpdateCardField {...item} />;
      case 'agentUpdateCardField':
        return <MessageAgentUpdateCardField {...item} />;
      case 'intelligenceGuidance':
        return <MessageEventIntGuidance {...item} />;
      case 'agentUpdateConvTag':
        return <MessageAgentUpdateConvTag {...item} />;
      case 'initConv':
        return <EventInitConv {...item} />;
      case 'copy_statistics':
        return <EventCopyButton {...item} />;
      case 'agentSendSensitiveWords':
        return <EventSensitiveWords {...item} handleReEdit={handleReEdit} />;
      case 'quick_btn_click':
        return <MessageClickQuickBtn {...item} />;
      case 'agent_redirect':
        return <EventAgentRedirect {...item} />;
      case 'conv_redirect_summary':
        return <EventRedirectSummary {...item} />;
      case 'phone_check':
        return <EventPhoneCheck {...item} />;
      case 'wechat_copy':
        return <EventWechatCopy {...item} />;
      case 'msg_app_open':
        return <EventMsgAppOpen {...item} />;
      default:
        return <EventDefault {...item} />;
    }
  };

  return <EventBox hasStreamBottom={isLastStream && !has_operator_msg}>{renderEvent(props)}</EventBox>;
};

export default MessageBase;
